/**
 * Page header with title and "Add User" button for User Management.
 *
 * Extracted from UserManagementPage.tsx (Sub-PR 6.3).
 */

import { useTranslation } from 'react-i18next'
import { Users, Plus } from 'lucide-react'

interface UserPageHeaderProps {
  onAddUser: () => void
}

export function UserPageHeader({ onAddUser }: UserPageHeaderProps): React.ReactElement {
  const { t } = useTranslation('admin')

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="rounded-lg bg-[#4e5e82]/10 p-2 dark:bg-[#8a9bba]/15">
          <Users className="h-6 w-6 text-[#4e5e82] dark:text-[#8a9bba]" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-stone-900 dark:text-stone-100">
            {t('users.title')}
          </h1>
          <p className="text-sm text-stone-500 dark:text-stone-400">{t('users.description')}</p>
        </div>
      </div>
      <button
        onClick={onAddUser}
        className="flex items-center gap-2 rounded-lg bg-[#4e5e82] px-4 py-2 text-white transition-colors hover:bg-[#5c6e94]"
      >
        <Plus className="h-4 w-4" />
        {t('users.addUser')}
      </button>
    </div>
  )
}
